import { render, staticRenderFns } from "./transportManagement.vue?vue&type=template&id=baec35ca&scoped=true"
import script from "./transportManagement.vue?vue&type=script&lang=js"
export * from "./transportManagement.vue?vue&type=script&lang=js"
import style0 from "./transportManagement.vue?vue&type=style&index=0&id=baec35ca&prod&lang=css"
import style1 from "./transportManagement.vue?vue&type=style&index=1&id=baec35ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baec35ca",
  null
  
)

export default component.exports